"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectPlan = exports.ProjectPlanTargets = exports.ProjectPlatforms = exports.ProjectPlanDurations = void 0;
const resource_model_1 = require("./resource.model");
const label_model_1 = require("./label.model");
/**
 * Expressed in months (WEEK is an exception, with value 0).
 */
var ProjectPlanDurations;
(function (ProjectPlanDurations) {
    ProjectPlanDurations[ProjectPlanDurations["WEEK"] = 0] = "WEEK";
    ProjectPlanDurations[ProjectPlanDurations["MONTH_1"] = 1] = "MONTH_1";
    ProjectPlanDurations[ProjectPlanDurations["MONTH_2"] = 2] = "MONTH_2";
    ProjectPlanDurations[ProjectPlanDurations["MONTH_3"] = 3] = "MONTH_3";
    ProjectPlanDurations[ProjectPlanDurations["MONTH_6"] = 6] = "MONTH_6";
    ProjectPlanDurations[ProjectPlanDurations["YEAR_1"] = 12] = "YEAR_1";
    ProjectPlanDurations[ProjectPlanDurations["LIFETIME"] = 9999] = "LIFETIME";
})(ProjectPlanDurations || (exports.ProjectPlanDurations = ProjectPlanDurations = {}));
var ProjectPlatforms;
(function (ProjectPlatforms) {
    ProjectPlatforms["WEB"] = "web";
    ProjectPlatforms["IOS"] = "ios";
    ProjectPlatforms["ANDROID"] = "android";
    ProjectPlatforms["MACOS"] = "macos";
    ProjectPlatforms["WINDOWS"] = "windows";
})(ProjectPlatforms || (exports.ProjectPlatforms = ProjectPlatforms = {}));
var ProjectPlanTargets;
(function (ProjectPlanTargets) {
    ProjectPlanTargets["USERS"] = "users";
    ProjectPlanTargets["TEAMS"] = "teams";
})(ProjectPlanTargets || (exports.ProjectPlanTargets = ProjectPlanTargets = {}));
/**
 * Table: `idea_projects_plans`.
 *
 * Indexes:
 *   - `project-order-index` (LSI, all).
 */
class ProjectPlan extends resource_model_1.Resource {
    load(x, languages) {
        super.load(x);
        this.project = this.clean(x.project, String);
        this.planId = this.clean(x.planId, String);
        this.storePlanId = this.clean(x.storePlanId, String);
        this.price = this.clean(x.price, Number);
        this.currency = this.clean(x.currency, String, 'EUR');
        this.currencySymbol = this.clean(x.currencySymbol, String, '€');
        this.priceStr = this.clean(x.priceStr, String);
        this.duration = this.clean(x.duration, Number, ProjectPlanDurations.MONTH_1);
        this.platforms = x.platforms ? this.clean(x.platforms, String) : [ProjectPlatforms.WEB];
        this.title = new label_model_1.Label(x.title, languages);
        this.description = new label_model_1.Label(x.description, languages);
        this.order = this.clean(x.order, Number, 0);
        this.special = this.clean(x.special, Boolean);
        this.target = this.clean(x.target, String, ProjectPlanTargets.TEAMS);
    }
    safeLoad(newData, safeData, languages) {
        this.safeLoad(newData, safeData, languages);
        this.project = safeData.project;
        this.planId = safeData.planId;
        this.special = safeData.special;
        this.target = safeData.target;
    }
    validate(languages) {
        let e = super.validate();
        if (this.iE(this.storePlanId))
            e.push('storePlanId');
        if (this.iE(this.price))
            e.push('price');
        if (this.iE(this.currency))
            e.push('currency');
        if (this.iE(this.currencySymbol))
            e.push('currencySymbol');
        if (this.iE(this.priceStr))
            e.push('priceStr');
        if (!(this.duration in ProjectPlanDurations))
            e.push('duration');
        if (!this.platforms.length || this.platforms.some(p => !(p in ProjectPlatforms)))
            e.push('platforms');
        if (!(this.target in ProjectPlanTargets))
            e.push('target');
        e = e.concat(this.title.validate(languages));
        return e;
    }
}
exports.ProjectPlan = ProjectPlan;
